import React from "react";
import * as Rb from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Img_1 from "../assets/img/img1.png"
import Ss_offical from "../assets/img/s_offical.png"
import Foresight from "../assets/img/foresight.png"
import Muthumeena from "../assets/img/muthumeena.png"
import Tagstore from "../assets/img/tagstore.png"
import Tagtes from "../assets/img/tagtes.png"
import Sam from "../assets/img/sam.png"
import Food from "../assets/img/food.png"
import Mobile from "../assets/img/mobile.jpg"
import StudyDash from "../assets/img/studysmart.jpeg"
import Manuall from "../assets/img/manuall.png"
import Hrms from "../assets/img/hrms.png"
import Smp from "../assets/img/smp.jpeg"
import Portfolio from "../assets/img/portfolio.png"
import * as Bi from "react-icons/bs";
import { Link } from "react-router-dom";
// import {StoreData} from "../assets/data";
// import * as Bi from "react-icons/bs";
class Project extends React.Component
{
    render(){
        return(
            <div className="top_align mb-2">
               <Rb.Card className="shadow card_align">
                        <Rb.Card.Body>
                            <section>
                                <div className="main_header">
                                    <h1 className="">Projects</h1>
                                    <div className="divider"></div>
                                </div>
                            </section>
                            <section>
                            <Rb.Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3 mt-4">
                            <Rb.Tab eventKey="all" title="All">
                                <Rb.Row>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={Img_1} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                            <h6 className="mb-1 w_color">2GrowHr (payroll Application)</h6>
                                            <p className="sb">Web Application</p>
                                        </div>
                                    </Rb.Col>
                                  
                                    
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Mobile} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">2GrowHr Mobile Application</h6>
                                        <p className="sb">Mobile Application</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Manuall} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">2GrowHr Manuall Website</h6>
                                        <p className="sb">ReactJs</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Foresight} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Foresight Offical Website</h6>
                                        <p className="sb">Static Website Wordpress</p>
                                    </div>
                                    </Rb.Col>
                                    {/* 2 row */}
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Muthumeena} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                    <h6 className="mb-1 w_color">Muthumeena Agencies Offical Website</h6>
                                        <p className="sb">Static Website Wordpress</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Ss_offical} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Study Smart Offical Webpage</h6>
                                        <p className="sb">static Website</p>
                                       
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Tagtes} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        
                                        <h6 className="mb-1 w_color">Tag Technology Services</h6>
                                        <p className="sb">Static Website React</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Tagstore} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">TagIT Store</h6>
                                        <p className="sb">Form Application Wordpress</p>
                                    </div>
                                    </Rb.Col>
                                    {/* 3 row */}
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Sam} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Sams Marine College</h6>
                                        <p className="sb">Figma Design</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Food} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        
                                        <h6 className="mb-1 w_color">Menu Stall</h6>
                                        <p className="sb">Figma Design</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Portfolio} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Portfolio</h6>
                                        <p className="sb">ReactJs</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={StudyDash} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">StudySmart LMS Application</h6>
                                        <p className="sb">Web Application</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Smp} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Smps Billing Application</h6>
                                        <p className="sb">Web Application</p>
                                    </div>
                                    </Rb.Col>
                                </Rb.Row>
                            </Rb.Tab>
                            {/*  Web application */}
                            <Rb.Tab eventKey="webapp" title="Web Applicaton">
                            
                                <Rb.Row>
                                   <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={Hrms} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                            <h6 className="mb-1 w_color">2GrowHr (HRMS Application)</h6>
                                            <p className="sb">Web Application</p>
                                        </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={Img_1} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                            <h6 className="mb-1 w_color">2GrowHr (payroll Application)</h6>
                                            <p className="sb">Web Application</p>
                                        </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={StudyDash} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                            <h6 className="mb-1 w_color">StudySmart LMS Application</h6>
                                            <p className="sb">Web Application</p>
                                        </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={Smp} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                            <h6 className="mb-1 w_color">Smps Billing Application</h6>
                                            <p className="sb">Web Application</p>
                                        </div>
                                    </Rb.Col>
                                </Rb.Row>
                           
                            </Rb.Tab>
                            {/* Static Website */}
                            <Rb.Tab eventKey="statweb" title="Static Website">
                                <Rb.Row>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Ss_offical} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Study Smart Offical Webpage</h6>
                                        <p className="sb">static Website</p>
                                       
                                    </div>
                                    </Rb.Col>
                                </Rb.Row>
                            </Rb.Tab>
                            {/*  wordpress website*/}
                            <Rb.Tab eventKey="wordpress" title="Wordpress">
                                <Rb.Row>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Tagstore} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">TagIT Store</h6>
                                        <p className="sb">Form Application Wordpress</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Muthumeena} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                    <h6 className="mb-1 w_color">Muthumeena Agencies Offical Website</h6>
                                        <p className="sb">Static Website Wordpress</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Foresight} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Foresight Offical Website</h6>
                                        <p className="sb">Static Website Wordpress</p>
                                    </div>
                                    </Rb.Col>
                                </Rb.Row>
                            
                                   
                            </Rb.Tab>
                            {/* react js */}
                            <Rb.Tab eventKey="react" title="React js">
                                <Rb.Row>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Manuall} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">2GrowHr Manuall Website</h6>
                                        <p className="sb">ReactJs</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Portfolio} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        <h6 className="mb-1 w_color">Portfolio</h6>
                                        <p className="sb">ReactJs</p>
                                    </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                    <div className="con">
                                        <Rb.Image fluid src={Tagtes} alt="image" className="pro_h image" /> 
                                        <div className="overlay">
                                            <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                        </div>
                                    </div>
                                    <div className="mt-2 px-2">
                                        
                                        <h6 className="mb-1 w_color">Tag Technology Services</h6>
                                        <p className="sb">Static Website React</p>
                                    </div>
                                    </Rb.Col>
                                </Rb.Row>
                            </Rb.Tab>
                            <Rb.Tab eventKey="figma" title="figma Design">
                                <Rb.Row>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={Sam} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                          
                                            <h6 className="mb-1 w_color">Sams Marine College</h6>
                                            <p className="sb">Figma Design</p>
                                        </div>
                                    </Rb.Col>
                                    <Rb.Col sm={12} md={6} lg={4} xl={4} className="mb-3">
                                        <div className="con">
                                            <Rb.Image fluid src={Food} alt="image" className="pro_h image" /> 
                                            <div className="overlay">
                                                <div class="text"><Bi.BsEyeFill className="y_color"/></div>
                                            </div>
                                        </div>
                                        <div className="mt-2 px-2">
                                           
                                            <h6 className="mb-1 w_color">Meal Slate</h6>
                                            <p className="sb">Figma Design</p>
                                        </div>
                                    </Rb.Col>
                                </Rb.Row>
                            </Rb.Tab>
                            </Rb.Tabs>
                            </section>
                        </Rb.Card.Body>
                    </Rb.Card> 
            </div>
        )
    }
}
export default Project